import React from 'react'

const StatusManageRegist_5 = () => {
  return (
    <div></div>
  )
}

export default StatusManageRegist_5